/**
 * Module Santé — conteneur principal.
 *
 * Onglet Santé de Life App (CDC §4.2). Tant que l'onboarding santé n'est pas
 * terminé, on présente le parcours d'activation ; ensuite, la navigation
 * interne expose les 5 écrans : Aujourd'hui, Tendances, Dossier médical,
 * Coach, Réglages.
 *
 * Route : /sante (cf. App.js).
 */
import React, { useEffect, useState } from 'react'
import { Box, Container, IconButton, Stack, Tab, Tabs, Typography } from '@mui/material'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded'
import { useNavigate } from 'react-router-dom'

import { santeApi } from '../api/santeApi'
import { HEALTH_ACCENT, Loading, PAGE_BG } from './shared'
import OnboardingView from './OnboardingView'
import TodayView from './TodayView'
import TrendsView from './TrendsView'
import MedicalRecordView from './MedicalRecordView'
import CoachView from './CoachView'
import SettingsView from './SettingsView'

const TABS = [
  { label: "Aujourd'hui", render: () => <TodayView /> },
  { label: 'Tendances', render: () => <TrendsView /> },
  { label: 'Dossier médical', render: () => <MedicalRecordView /> },
  { label: 'Coach', render: () => <CoachView /> },
  { label: 'Réglages', render: () => <SettingsView /> },
]

export default function SanteModule() {
  const navigate = useNavigate()
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)
  const [tab, setTab] = useState(0)

  const loadProfile = async () => {
    setLoading(true)
    const p = await santeApi.getProfile()
    setProfile(p)
    setLoading(false)
  }

  useEffect(() => {
    loadProfile()
    window.scrollTo(0, 0)
  }, [])

  return (
    <Box sx={{ bgcolor: PAGE_BG, minHeight: '100vh', pb: 6 }}>
      <Container maxWidth="lg" sx={{ pt: 3 }}>
        <Stack direction="row" spacing={1.5} alignItems="center" sx={{ mb: 2 }}>
          <IconButton onClick={() => navigate('/')} sx={{ color: '#fff' }}>
            <ArrowBackIcon />
          </IconButton>
          <FavoriteRoundedIcon sx={{ color: HEALTH_ACCENT }} />
          <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: 22 }}>
            Module Santé
          </Typography>
        </Stack>

        {loading ? (
          <Loading label="Ouverture de votre espace santé…" />
        ) : !profile || !profile.onboarding_completed ? (
          <OnboardingView profile={profile} onDone={loadProfile} />
        ) : (
          <>
            <Tabs
              value={tab}
              onChange={(_, v) => setTab(v)}
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                mb: 3,
                '& .MuiTab-root': {
                  color: 'rgba(255,255,255,0.55)',
                  textTransform: 'none',
                  fontWeight: 600,
                },
                '& .Mui-selected': { color: `${HEALTH_ACCENT} !important` },
                '& .MuiTabs-indicator': { backgroundColor: HEALTH_ACCENT },
              }}
            >
              {TABS.map((t) => (
                <Tab key={t.label} label={t.label} />
              ))}
            </Tabs>
            {TABS[tab].render()}
          </>
        )}
      </Container>
    </Box>
  )
}
